import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    identifier: String
  }

  open(e) {
    document.querySelector(`#${this.identifierValue}`).modal.open(e);
  };
}
